import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import TrialMembersPageHeader from './components/TrialMembersPageHeader';
import TrialMembersTable from './components/TrialMembersTable';
import { SearchFilters } from './types';

const TrialMembers = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();

  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-trialDate');

  return (
    <>
      <TrialMembersPageHeader
        orderingValue={orderingValue}
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
      />

      <TrialMembersTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default TrialMembers;
